import { hashHistory } from 'react-router';

// Get 'app' path
import { path as CPM_PATH } from '../..';

// All paths
const PATHS = {
  WORKSPACES: 'workspaces',
  GROUPS: 'groups',
  PARTNERS: 'partners',
  SLUGS: 'slugs',
  SERVICE_FEE_RULES: 'service_fee_rules',
  SETTINGS: 'settings',
};

// Exported paths
export const MAIN_PATH = PATHS.WORKSPACES;
export const GROUPS_PATH = PATHS.GROUPS;
export const SETTINGS_PATH = PATHS.SETTINGS;
export const PARTNERS_PATH = PATHS.PARTNERS;
export const SLUGS_PATH = PATHS.SLUGS;
export const SERVICE_FEE_RULES_PATH = PATHS.SERVICE_FEE_RULES;

// Root
const CPM_WORKSPACES_PATH = `${CPM_PATH}/${MAIN_PATH}`;

// List workspace
export const listPath = () => CPM_WORKSPACES_PATH;
export const navigateToList = () => {
  hashHistory.push(listPath());
};

export const showPath = (id) => `${CPM_WORKSPACES_PATH}/${id}`;
export const navigateToShow = (id) => {
  hashHistory.push(showPath(id));
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/navigation.js